<template>
  <div class="flex">
    <div class="sidebar">
      <div v-for="route in filteredRoutes" :key="route.name">
        <div v-bind:class="{
          active_tab: route.name === getCurrentRoute,
          inactive_tab: route.name !== getCurrentRoute,
        }" @click="goTo(route)">
          <div class="flex flex-col items-center text-white py-5 cursor-pointer">
            <img :src="route.icon" width="30" height="30">
            <p>{{ route.label }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="content">
      <slot />
    </div>
  </div>
</template>

<script>
import AuthBehavior from "@/mixins/AuthBehavior";

export default {
  mixins: [AuthBehavior],
  data() {
    return {
      routes: [
        {
          name: "rpm-dashboard",
          label: "Dashboard",
          icon: require("@/assets/rpm-ccm-tabs/dashboard.svg"),
          permission: "access_page_dashboard",
        },
        {
          name: "rpm-dashboard-patients",
          label: "Patients",
          icon: require("@/assets/rpm-ccm-tabs/patients.svg"),
          permission: "access_page_patients",
        },
        {
          name: "rpm-dashboard-order-forms",
          label: "Order Forms",
          icon: require("@/assets/rpm-ccm-tabs/patients.svg"),
          permission: "access_page_order_forms",
        },
        {
          name: "rpm-dashboard-tasks",
          label: "Tasks",
          icon: require("@/assets/rpm-ccm-tabs/fa-file-lines.svg"),
          permission: "access_page_your_tasks",
        },
        {
          name: "rpm-dashboard-alerts",
          label: "Alerts",
          icon: require("@/assets/rpm-ccm-tabs/alerts.svg"),
          permission: "access_page_alerts",
        },
        {
          name: "rpm-dashboard-rpm-data",
          label: "RPM Data",
          icon: require("@/assets/rpm-ccm-tabs/rpm-data.svg"),
          permission: "access_page_rpm_data",
        },
        {
          name: "rpm-dashboard-ccm-data",
          label: "CCM Data",
          icon: require("@/assets/rpm-ccm-tabs/ccm-data.svg"),
          permission: "access_page_ccm_data",
        },
        {
          name: "rpm-dashboard-billing-summary",
          label: "Billing",
          icon: require("@/assets/rpm-ccm-tabs/bank-note.svg"),
          permission: "access_page_billing",
        },
        {
          name: "rpm-dashboard-reports",
          label: "Reports",
          icon: require("@/assets/rpm-ccm-tabs/fa-file-lines.svg"),
          permission: "access_page_reports",
        },
      ],
      filteredRoutes: [],
    };
  },
  computed: {
    getCurrentRoute() {
      return this.$route.name;
    },
  },
  methods: {
    async fetchAuthUser(context) {
      if (!context.$store.state.patients.authUser || !context.$store.state.patients.authUser.behaviors) {
        await context.$store.dispatch('getAuthUser');
      }
      return context.$store.state.patients.authUser;
    },
    async filterRoutes() {
      const context = { $store: this.$store };
      const authUser = await this.fetchAuthUser(context);
      const routesWithPermission = await Promise.all(
          this.routes.map(async (route) => {
            const hasPermission = await this.hasPermission(authUser, route.permission);
            return hasPermission ? route : null;
          })
      );
      this.filteredRoutes = routesWithPermission.filter(route => route !== null);
    },
    goTo(route) {
      if (this.$route.name !== route.name) {
        this.$router.push({ name: route.name });
      }
    },
  },
  created() {
    this.filterRoutes();
  },
};
</script>

<style scoped>
.sidebar {
  background: linear-gradient(180deg, #5186ef 50%, #9affcd 100%);
  width: 100px;
  min-height: calc(100vh);
}

.content {
  background: #ddf1f7;
  width: calc(100vw - 100px);
  min-height: calc(100vh);
  overflow: auto;
  padding: 1rem;
}

.active_tab {
  background: rgba(255, 255, 255, 25%);
}

.inactive_tab:hover {
  background: rgba(255, 255, 255, 5%);
}
</style>